import { render, staticRenderFns } from "./WkUploadCell.vue?vue&type=template&id=cb1a705e&scoped=true"
import script from "./WkUploadCell.vue?vue&type=script&lang=js"
export * from "./WkUploadCell.vue?vue&type=script&lang=js"
import style0 from "./WkUploadCell.vue?vue&type=style&index=0&id=cb1a705e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb1a705e",
  null
  
)

export default component.exports